export class CustomError extends Error {
	constructor(name, statusCode, description, isPopup = false) {
		super(description);

		Object.setPrototypeOf(this, new.target.prototype);
		this.name = name;
		this.statusCode = statusCode;
		this.isPopup = isPopup;
		//handle IE11
		if (Error.captureStackTrace) Error.captureStackTrace(this);
	}
}
